import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import LandingPage from "@/pages/LandingPage";
import RegistrationForm from "@/pages/RegistrationForm";
import SignaturePage from "@/pages/SignaturePage";
import DocumentsPage from "@/pages/DocumentsPage";
import RecapPage from "@/pages/RecapPage";
import ConfirmationPage from "@/pages/ConfirmationPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import QuitusFiscalGuide from "@/pages/QuitusFiscalGuide";
import CGVPage from "@/pages/CGVPage";
import ClientAuth from "@/pages/ClientAuth";
import ClientDashboard from "@/pages/ClientDashboard";
import MentionsLegalesPage from "@/pages/MentionsLegalesPage";
import ConfidentialitePage from "@/pages/ConfidentialitePage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <div className="App min-h-screen bg-slate-50">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/demande" element={<RegistrationForm />} />
          <Route path="/signature/:dossierId" element={<SignaturePage />} />
          <Route path="/documents/:dossierId" element={<DocumentsPage />} />
          <Route path="/recapitulatif/:dossierId" element={<RecapPage />} />
          <Route path="/confirmation" element={<ConfirmationPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/guide/quitus-fiscal" element={<QuitusFiscalGuide />} />
          <Route path="/cgv" element={<CGVPage />} />
          <Route path="/connexion" element={<ClientAuth />} />
          <Route path="/espace-client" element={<ClientDashboard />} />
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          <Route path="/confidentialite" element={<ConfidentialitePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
